export interface PreviewItem {
  image: string
  alt: string
  caption: string
}

export const previewItems: PreviewItem[] = [
  {
    image: 'https://cdn.magicpatterns.com/uploads/9umMKPgnph35xTznSfVRnV/Captura_de_pantalla_2026-09-14_a_la(s)_12.06.56_a._m..png',
    alt: 'Scooping technique page showing the correct and incorrect body position side by side',
    caption: 'Technique Page — Scooping, correct vs incorrect',
  },
  {
    image: 'https://cdn.magicpatterns.com/uploads/8x1T2dCXduKhd9RWWCfKeD/Captura_de_pantalla_2026-09-14_a_la(s)_12.07.38_a._m..png',
    alt: 'Ground ball technique page broken into four photographed steps with a coach tip box',
    caption: 'Ground Ball Technique — four steps, every time',
  },
  {
    image: 'https://cdn.magicpatterns.com/uploads/ii264Ze5KgHmsZqoLr1Adf/Captura_de_pantalla_2026-09-14_a_la(s)_12.08.24_a._m..png',
    alt: 'Defensive stance page with footwork photos and the drop step explained',
    caption: 'Defensive Stance — footwork and the drop step',
  },
  {
    image: 'https://cdn.magicpatterns.com/uploads/nX9RnuCG6HHTJi6suzTGBf/Captura_de_pantalla_2026-09-14_a_la(s)_12.08.37_a._m..png',
    alt: 'Block 7 drill page with setup, duration, progressions and mistakes for three drills',
    caption: 'Drill Cards — setup, timing, progressions, mistakes',
  },
  {
    image: 'https://cdn.magicpatterns.com/uploads/xxiJRdFbfRpQJCwoSaFFyT/Captura_de_pantalla_2026-09-14_a_la(s)_12.09.46_a._m..png',
    alt: 'Block 7 opening page on physical preparation for U12 players',
    caption: 'Block Opener — physical preparation for U12',
  },
  {
    image: 'https://cdn.magicpatterns.com/uploads/nxg6szpWV6sLTFeBy99QbZ/Captura_de_pantalla_2026-09-14_a_la(s)_12.10.05_a._m..png',
    alt: 'Block 7 progressions page with ladder, T-drill and 3v3 pressure game cards',
    caption: 'Progressions — ladder work, T-drill and 3v3',
  },
]
